import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Container from '../../../Core/Container';
import MultiColumnLayout from '../MultiColumnLayout';

export const Wrapper = styled.div`
  background-color: ${({ colourOverrideBackground }) =>
    colourOverrideBackground || themeGet('colors.neutral_2')};
`;

export const StyledContainer = styled(Container)`
  & > h1,
  & > h2,
  & > h3,
  & > h4,
  & > h5,
  & > h6 {
    text-align: center;
    margin-bottom: 35px;
  }

  padding: 50px 0 60px;

  .toggleContainer {
    text-align: center;
    margin-bottom: 20px;
  }

  .left-toggle.solid-on-light-bg:active,
  .left-toggle.solid-on-light-bg:hover,
  .left-toggle.solid-on-light-bg:focus,
  .right-toggle.ghost-on-light-bg:hover,
  .right-toggle.ghost-on-light-bg:active,
  .right-toggle.ghost-on-light-bg:focus {
    background-color: ${themeGet('colors.orange')};
    border: ${themeGet('colors.orange')};
  }

  .right-toggle {
    background-color: ${themeGet('colors.white')};
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
  }

  .left-toggle {
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
  }

  .active {
    background-color: ${themeGet('colors.orange')};
    color: ${themeGet('colors.white')};
  }

  .inactive {
    background-color: ${themeGet('colors.white')};
    color: ${themeGet('colors.black')};
  }

  .toggleContainer {
    display: flex;
    width: auto;
  }

  .right-toggle,
  .left-toggle {
    min-width: unset;
    max-width: 50%;
  }

  .columns-6 > div:nth-child(odd) {
    display: none;
  }

  .showFirstCardLeft.columns-6 > div:first-child,
  .showFirstCardRight.columns-6 > div:first-child,
  .showThirdCardLeft.columns-6 > div:nth-child(3),
  .showThirdCardRight.columns-6 > div:nth-child(3) {
    display: flex;
  }

  button.hideButton {
    display: none;
  }

  .FirstCardLeftButton,
  .FirstCardRightButton {
    margin-bottom: 20px;
  }

  .ThirdCardLeftButton,
  .ThirdCardRightButton {
    margin-top: 20px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    padding: 50px 90px 60px;

    display: flex;
    flex-direction: column;
    align-items: center;

    .toggleContainer {
      display: block;
    }
    .right-toggle,
    .left-toggle {
      width: 160px;
    }

    .FirstCardLeftButton,
    .FirstCardRightButton,
    .ThirdCardLeftButton,
    .ThirdCardRightButton {
      display: none;
    }

    .columns-6 > div:nth-child(odd) {
      display: flex;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    padding: 70px 0 90px;
    display: block;

    .right-toggle,
    .left-toggle {
      width: 240px;
    }
  }
`;

export const Cards = styled(MultiColumnLayout).attrs(({ columns }) => ({
  columns,
}))`
  @media only screen and (max-width: calc(${themeGet(
    'breakpoints.lg'
  )} - 1px)) {
    > div,
    article {
      margin-top: 20px;

      &:first-child {
        margin-top: 10px;
      }
    }
  }
  justify-content: center;
`;
